import { render, staticRenderFns } from "./alertdetail.vue?vue&type=template&id=660fbbb9"
import script from "./alertdetail.vue?vue&type=script&lang=js"
export * from "./alertdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports